module.exports = __webpack_public_path__ + "img/about_introduce_icon2@1x.86681d3c.png";